import { buildStyledComponent, px2rem } from 'decisiv-ui-utils';
import styled from 'styled-components';

import Img from 'elements/Img';

const styles = `
  width: auto;
  height: ${px2rem(50)};
`;

export default buildStyledComponent(
  'LogoImg',
  styled(Img),
  styles,
);



// WEBPACK FOOTER //
// ./compositions/Logo/LogoImg.js